import styled from 'styled-components';
import { motion } from 'framer-motion';

const ServicesContainer = styled.div`
  height: 800px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--color-black);

  @media (max-width: 768px) {
    height: 1100px;
  }

  @media (max-width: 480) {
    height: 1300px;
  }
`;

const ServicesWrapper = styled(motion.div)`
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  grid-gap: 1.5rem;
  padding: 0 50px;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;

const ServicesCard = styled(motion.article)`
  background: var(--color-white);

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  border-radius: 10px;
  max-height: 340px;
  padding: 30px;
  box-shadow: var(--box-shadow);

  &:hover {
    cursor: pointer;
  }
`;

const ServicesIcon = styled.img`
  width: 96px;
  height: 96px;
  margin-bottom: 1rem;
`;

const ServicesHeading = styled.h1`
  font-size: 3rem;
  line-height: 1.1;
  color: var(--color-white);
  font-weight: 600;
  margin-bottom: 16px;

  @media (max-width: 480px) {
    font-size: 32px;
  }
`;

const ServicesTitle = styled.h2`
  font-size: 1.25rem;
  margin-bottom: 10px;
`;

const ServicesParagraph = styled.p`
  font-size: 1rem;
  text-align: center;
`;

export {
  ServicesContainer,
  ServicesWrapper,
  ServicesHeading,
  ServicesCard,
  ServicesIcon,
  ServicesTitle,
  ServicesParagraph
};
